<template>
  <div class="goodsdetail">
    <!--头部导航-->
    <GlobTopNav title="商品详情"></GlobTopNav>

    <div class="detail-content" v-if="datas != ''">
      <!--banner-->
      <van-swipe :autoplay="3000" style="height: 7.5rem">
        <van-swipe-item v-for="items in banner" :key="items.id">
          <img
            v-lazy="items"
            style="width: 100%; height: 100%"
            onerror="src='/static/errorimg1.png'"
          />
        </van-swipe-item>
      </van-swipe>

      <!--商品信息-->
      <div class="product-detail" :class="datas.source != 2 && datas.source != 3 ? '' : 'noMargin'">
        <div class="product-price">
          <span class="product-price-jf">
            <span v-if="datas.points">{{ datas.points }}{{ unit }}</span>
            <span class="product-price" v-if="datas.price_cash">
              <span v-if="datas.points">+</span>
              {{ datas.price_cash }}元
            </span>
          </span>
          <span class="product-price-jg" v-if="$store.state.webCount.market_status == 1">
            市场价:{{ datas.market_price }}元
          </span>
        </div>

        <div class="product-name">
          <span class="tagbox">
            <span class="tag xl" v-if="datas.source == 4"> 一乡一物 </span>
            <span class="tag xl" v-if="datas.source == 3">卡券</span>
            <span class="tag zc" v-if="datas.source == 2">直充</span>
            <span plain class="tag jd" v-if="datas.source == 1">优选</span>
            <span class="tag yx" v-if="datas.source == 6">严选</span>
          </span>
          {{ datas.name }}
        </div>
        <div class="stock-wrap" v-if="stockShow">
          <span v-if="datas.stock_status === 1">库存：{{ datas.stock_number }}</span>
          <span v-if="datas.stock_member_status === 1 && isLogin">
            剩余兑换数量：{{ datas.stock_member_number - datas.stock_member_count < 0 ? 0 : datas.stock_member_number - datas.stock_member_count }}
          </span>
        </div>
        <div class="product-number">商品编号：{{ datas.code }}</div>
      </div>

      <!-- 购买信息 -->
      <div class="product-set">
        <div class="product-set-cont">
          <!--步进器-->
          <div v-if="datas.source != 2 && datas.source != 3" class="change-number">
            <span class="set-title" style="align-items: center">{{ $common.cardName().type ? '购买': '兑换' }}数量</span>
            <van-stepper
              class="set-stepper"
              @input="descInput(nums)"
              :integer="true"
              :min="1"
              :max="9999"
              v-model="nums"
            />
          </div>

          <div v-if="datas.source == 2 || datas.source == 3" class="change-number">
            <span class="set-title">兑换数量</span>
            <span>×1</span>
          </div>

          <!--地址选择-->
          <div
            v-if="datas.source != 2 && datas.source != 3"
            class="product-address"
            @click="cityPickerShow"
          >
            <div class="ps">
              <span class="set-title" style=""> 配送至：</span>
              <div class="change-address">
                <span class="set-title">
                  <img src="./../../assets/img/detail-dw.png" alt="" />
                  {{ address.area }}
                </span>
                <van-icon style="line-height: 0.48rem" name="arrow" color="rgba(38, 38, 38, 0.3)" />
              </div>
            </div>
            <span class="xh" v-if="datas.status == 0">商品已下架</span>
            <span class="xh" v-if="datas.status != 0 && noStock">
              有货
              <span v-if="datas.source == 1">本品由京东发货，并提供售后服务</span>
            </span>
            <span class="xh" v-if="datas.status != 0 && !noStock">当前地址无库存</span>
          </div>
        </div>
      </div>

      <!--商品详情-->
      <div class="product-xq">
        <div class="xq-title">商品详情</div>
        <div v-if="datas.content_wap != ''" v-html="datas.content_wap" class="clear goodstab">
          {{ datas.content_wap }}
        </div>
        <div v-if="datas.content_wap == ''" style="text-align: center; padding: 0.2rem 0">
          暂无详情信息!
        </div>
      </div>
    </div>

    <!--立即购买弹窗-->
    <van-sku v-if="datas.source != 2 || datas.source != 3" v-model="showCustomAction" :sku="sku">
      <!-- 头部信息 -->
      <template slot="sku-header" slot-scope="props">
        <div class="van-hairline--bottom van-sku-header">
          <div class="van-sku-header__img-wrap">
            <img v-lazy="goods.product_img" />
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku__goods-name van-ellipsis"></div>
            <div class="van-sku__goods-price">
              <p class="ellipseal">
                <span plain class="jd" v-if="goods.dummy == 1">优选</span>
                {{ goods.name }}
              </p>
              <span class="van-sku__price-symbol"></span>
              <span class="van-sku__price-num">{{ goods.points_price }}</span>
            </div>
            <i class="van-sku__close-icon van-icon van-icon-close" @click="showCustom"></i>
          </div>
        </div>
      </template>
      <!-- 商品sku展示区 -->
      <template slot="sku-group" slot-scope="props">
        <div></div>
      </template>
      <!-- 商品数量选择 -->
      <template slot="sku-stepper" slot-scope="props">
        <div class="van-sku-stepper-stock">
          <div class="van-sku-stepper-container">
            <div class="van-sku__stepper-title">数量：</div>
            <div class="van-sku__stepper van-stepper">
              <van-stepper v-model="nums" />
            </div>
          </div>
          <!--<div class="van-sku__stock">剩余227件</div>-->
          <!--<div class="van-sku__quota">每人限购15件</div>-->
        </div>
      </template>
      <!-- 留言 -->
      <template slot="sku-messages" slot-scope="props">
        <div></div>
      </template>
      <!-- 底部按钮 -->
      <template slot="sku-actions" slot-scope="props">
        <div class="van-sku-actions">
          <!--<van-button bottom-action>积分兑换</van-button>-->
          <!-- 直接触发 sku 内部事件，通过内部事件执行 onBuyClicked 回调 -->
          <van-button class="theme-bg" type="primary theme-bg" bottom-action @click="onBuyClicked">
            确定
          </van-button>
        </div>
      </template>
    </van-sku>
    <!--地址选择弹框-->
    <city-picker
      ref="cityPicker"
      @listenSitedata="geSitedatas"
      v-if="datas.source != 2 && datas.source != 3"
    ></city-picker>
    <!-- <City-Picker ref="CityPicker" v-on:listenSitedata="geSitedatas" v-if="datas.source == 1"></City-Picker> -->
    <!--无货-->
    <!-- <van-goods-action class="down" v-if="datas.status == 0">
      <span>已下架</span>
    </van-goods-action> -->

    <!--底部-->
    <van-goods-action v-if="datas != '' && noStock == true">
      <router-link
        v-if="datas.source != 2 && datas.source != 3"
        class="product-cart"
        to="/user/cart"
      >
        <img src="./../../assets/img/dhd.svg" />
        <span>{{ $common.cardName().name }}</span>
        <span class="cartNum theme-bg" v-if="shopnum > 0">{{ shopnum }}</span>
      </router-link>

      <a
        style="background: transparent"
        v-if="datas.source != 2 && datas.source != 3 && datas.status != 0"
        class="product-cart"
        @click="addCollect"
      >
        <img
          :src="
            collect_status == 1
              ? require('./../../assets/img/a-sc.svg')
              : require('./../../assets/img/sc.svg')
          "
        />
        <span>收藏</span>
      </a>

      <a
        style="background: transparent"
        v-if="datas.source != 2 && datas.source != 3 && datas.status == 0"
        class="van-hairline van-goods-action-mini-btn product-cart"
      >
        <!-- <i
          class="van-icon iconfont"
          :class="collect_status == 1 ? 'theme-col icon-xingxing' : 'icon-kong'"
          style="font-size: 0.2rem; margin-bottom: 0.04rem"
        ></i> -->
        <img
          :src="
            collect_status == 1
              ? require('./../../assets/img/a-sc.svg')
              : require('./../../assets/img/sc.svg')
          "
        />
        <span>收藏</span>
      </a>
      <div class="forBag" v-if="datas.status != 0">
        <van-goods-action-button
          v-if="datas.source != 2 && datas.source != 3"
          :class="!disabled ? 'theme-bg theme-bd' : ''"
          :text="`加入${$common.cardName().name}`"
          style="color: #fff"
          @click="addCart"
        />
      </div>
      <div class="immediately" v-if="(datas.source == 2 || datas.source == 3) && datas.status != 0">
        <van-goods-action-button
          :class="[!disabled ? 'theme-bg theme-bd' : '', 'immediately-change']"
          text="立即兑换"
          style="color: #fff"
          @click="showCustom"
        />
      </div>
      <van-goods-action-button
        class="out-stock"
        text="商品已下架"
        style="color: #fff"
        v-if="datas.status == 0"
      />
    </van-goods-action>

    <!--京东无库存-->
    <van-goods-action
      style="box-shadow: 0rem 0rem 0.02rem 0.01rem #f2f2f2"
      v-if="datas != '' && noStock == false"
    >
      <router-link
        style="position: relative; background: transparent"
        class="product-cart"
        to="/user/cart"
      >
        <img src="./../../assets/img/dhd.svg" />
        <span>{{ $common.cardName().name }}</span>
        <span class="cartNum theme-bg" v-if="shopnum > 0">{{ shopnum }}</span>
      </router-link>
      <a
        style="background: transparent"
        v-if="datas.source != 2 && datas.source != 3"
        class="product-cart"
        @click="addCollect"
      >
        <!-- <i
          class="van-icon iconfont"
          :class="collect_status == 1 ? 'theme-col icon-xingxing' : 'icon-kong'"
          style="font-size: 0.2rem; margin-bottom: 0.04rem"
        ></i
        >收藏 -->
        <img
          :src="
            collect_status == 1
              ? require('./../../assets/img/a-sc.svg')
              : require('./../../assets/img/sc.svg')
          "
        />
        <span>收藏</span>
      </a>
      <van-goods-action-button
        v-if="datas.source != 2 && datas.source != 3"
        disabled
        :class="!disabled ? 'theme-bg theme-bd' : ''"
        class="out-stock"
        text="当前地址无库存"
      />
    </van-goods-action>
  </div>
</template>

<script>
import CityPicker from "@/pages/user/mysite/cityPicker";
import TopNav from "@/components/topnav";
import store from "../../vuex/store";
export default {
  name: "detail",
  components: {
    CityPicker,
    TopNav
  },
  store,
  computed: {
    unit: function() {
      return this.$store.state.unitinfo.name;
    },
    stockShow: function() {
      return this.$store.state.mallStockShow;
    }
  },
  data() {
    return {
      vanTabs: false,
      disabled: false,
      sitedDatas: "",
      sitedDatasName: "",
      collect_status: false,
      datas: "",
      goods: "",
      banner: "",
      type: "",
      dataIntArr: [],
      id: this.$route.query.id, //商品id
      nums: 1, //购买数量
      showCustomAction: false, //购买弹窗开启状态
      sku: {
        tree: [],
        list: []
      },
      // province:'',
      // city:1,
      // town:72,
      // county:2799,
      address: this.$store.state.address, //京东查库存显示地址
      shopnum: 0, //购物车数量
      ajaxfrom: {}, //查询京东数量
      noStock: true,
      stockid: "",
      collectid: "",
      isLogin: false
    };
  },
  //    beforeRouteLeave(to,from ,next){//解决分类列表进入后缓存与详情返回重新刷新页面的问题（重要内容）
  //      if(to.name==='GoodsList'){
  //        to.meta.keepAlive =true;
  //      }
  //      next()
  //    },

  methods: {
    cityPickerShow() {
      this.$refs.cityPicker.setSiteShow(true);
    },
    geSitedatas(datas) {
      console.log(datas);
      if (datas[3] != undefined && datas[3].name == "请选择") {
        this.$toast("请填写完成地址");
        return false;
      }
      var area = "";
      if (datas[0] != undefined) {
        area += datas[0].name;
      }
      if (datas[1] != undefined) {
        area += "-" + datas[1].name;
      }
      if (datas[2] != undefined) {
        area += "-" + datas[2].name;
      }
      if (datas[3] != undefined && datas[3].name != " ") {
        area += "-" + datas[3].name;
      }
      var json = {
        area: area,
        province_id: datas[0].id,
        city_id: datas[1].id,
        country_id: datas[2].id,
        town_id: datas[3] ? datas[3].id : 0
      };
      this.address = json;
      // this.$refs.cityPicker.setSiteShow(false);
      // this.$store.commit("setAddress", json);
      this.checksocket();
    },
    checksocket: function() {
      //查询京东库存
      var mallid = localStorage.getItem("mallid");
      this.$api.get(
        "/product/jd/stock",
        {
          id_example: mallid,
          id_product: this.stockid,
          id_province: this.address.province_id,
          id_city: this.address.city_id,
          id_county: this.address.country_id
        },
        res => {
          if (res.data.code == "100") {
            if (res.data.data[0].desc == "无货") {
              this.noStock = false;
            } else if (res.data.data[0].desc == "有货") {
              this.noStock = true;
            }
          }
        }
      );
    },
    descInput: function(nums) {
      if (nums < 1) {
        this.nums = 1;
      }

      if (nums >= 9999) {
        this.nums = 9999;
      }
    },
    goBack: function() {
      history.back(-1);
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    getDatas: function() {
      var mallid = localStorage.getItem("mallid");
      var isUser = localStorage.getItem("BLHuser");
      var userid = localStorage.getItem("user_id");
      if (isUser != undefined) {
        this.cartnum();
      }
      this.$api.get(
        "/product/detail",
        { id_example: mallid, id_product: this.id, user_id: userid },
        res => {
          if (res.data.code == "100") {
            this.datas = res.data.data;
            this.banner = res.data.data.images_run;
            this.stockid = res.data.data.id_product;
            if (res.data.data.is_collect == null) {
              this.collect_status = false;
              this.collectid = "";
            } else {
              res.data.data.is_collect == null
                ? (this.collect_status = false)
                : (this.collect_status = true);
              this.collectid = res.data.data.is_collect;
            }
            if (
              (res.data.data.source != 2 && res.data.data.source != 3) ||
              res.data.data.source != 5
            ) {
              this.checksocket();
              this.$store.commit("userInfo");
            }
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({ name: "NoteLogin" });
                })
                .catch(() => {});
            } else {
              this.$toast(res.data.message);
            }
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    },
    // 加入兑换袋
    addCart: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      if (isUser == undefined) {
        this.$dialog
          .confirm({
            title: "提示 ",
            message: "您还未登录是否去登录？"
          })
          .then(() => {
            this.$router.push({ name: "NoteLogin" });
          })
          .catch(() => {});
      } else {
        if (this.nums < 1) {
          this.$toast("商品数量必须大于0");
          this.nums = 1;
          return false;
        }
        this.$api.post(
          "user/cart/add",
          {
            id_example: mallid,
            token_user: isUser,
            id_product: this.id,
            number: this.nums,
            status: 1
          },
          res => {
            if (res.data.code == "100") {
              this.cartnum();
              //              this.$dialog.confirm({
              //                title:'提示',
              //                message: '该商品已加入购物车，是否立即兑换？'
              //              }).then(() => {
              //                this.$router.push({path:'/user/cart'})
              //              }).catch(() => {
              //                // on cancel
              //              });
              this.$toast(`加入${this.$common.cardName().name}成功`);
            } else {
              if (res.data.message == "token验证失败") {
                this.$dialog
                  .confirm({
                    title: "提示 ",
                    message: "您还未登录是否去登录？"
                  })
                  .then(() => {
                    this.$router.push({ name: "NoteLogin" });
                  })
                  .catch(() => {});
              } else {
                this.$toast(res.data.message);
              }
            }
          }
        );
      }
    },
    // 加入收藏

    addCollect: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      if (isUser == undefined) {
        this.$dialog
          .confirm({
            title: "提示 ",
            message: "您还未登录是否去登录？"
          })
          .then(() => {
            this.$router.push({ name: "NoteLogin" });
          })
          .catch(() => {});
      } else {
        if (this.collect_status == true) {
          this.$api.post(
            "/user/collection/delete",
            {
              id_example: mallid,
              token_user: isUser,
              id_cocollection: this.collectid
            },
            res => {
              if (res.data.code == "100") {
                this.collect_status = !this.collect_status;
                this.$toast("取消收藏成功！");
              } else {
                if (res.data.message == "token验证失败") {
                  this.$dialog
                    .confirm({
                      title: "提示 ",
                      message: "您还未登录是否去登录？"
                    })
                    .then(() => {
                      this.$router.push({ name: "NoteLogin" });
                    })
                    .catch(() => {});
                } else {
                  this.$toast(res.data.message);
                }
              }
            }
          );
        } else {
          this.$api.post(
            "user/collection/add",
            { id_example: mallid, token_user: isUser, id_product: this.id },
            res => {
              if (res.data.code == "100") {
                this.collectid = res.data.data;
                this.collect_status = !this.collect_status;
                this.$toast("收藏成功！");
              } else {
                if (res.data.message == "token验证失败") {
                  this.$dialog
                    .confirm({
                      title: "提示 ",
                      message: "您还未登录是否去登录？"
                    })
                    .then(() => {
                      this.$router.push({ name: "NoteLogin" });
                    })
                    .catch(() => {});
                } else {
                  this.$toast(res.data.message);
                }
              }
            }
          );
        }
      }
    },
    // 底部立即购买
    showCustom: function() {
      //实物走这
      if (
        this.datas.source == 0 ||
        this.datas.source == 1 ||
        this.datas.source == 5
      ) {
        this.showCustomAction = !this.showCustomAction;
      }
      //虚拟走这
      else {
        const url = window.location.href
        const isResetting = localStorage.getItem('isResetting')
        if(url.search('kmzhfl') != -1 && isResetting == 1) {
          this.$dialog.confirm({
              title: "提示 ",
              message: "为了你的账号安全，请修改初始密码后在下单"
            })
              .then(() => {
                this.$router.push({ name: "Password" });
              })
              .catch(() => {
                
              });
          return
        } 
        this.onBuyClicked();
      }
    },
    //购买虚拟商品
    onBuyClicked: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      if (isUser != undefined || isUser != "" || isUser != null) {
        this.$api.post(
          "user/cart/add",
          {
            id_example: mallid,
            token_user: isUser,
            id_product: this.id,
            number: this.nums,
            status: -1
          },
          res => {
            var id_cart = res.data.data.toString();
            if (res.data.code == "100") {
              this.$api.post(
                "/order/cart/create",
                { id_example: mallid, token_user: isUser, id_cart: id_cart },
                res => {
                  if (res.data.code == "100") {
                    this.$router.push({
                      path: "/affirmOrder",
                      query: { id: id_cart }
                    });
                  } else if (res.data.code == "-200") {
                    this.$dialog
                      .confirm({
                        title: "提示",
                        message: "积分不足请兑换积分"
                      })
                      .then(() => {
                        this.$router.push({
                          name: "Buypoints",
                          params: { points: res.data.message }
                        });
                      })
                      .catch(() => {});
                  } else {
                    if (res.data.message == "token验证失败") {
                      this.$dialog
                        .confirm({
                          title: "提示 ",
                          message: "您还未登录是否去登录？"
                        })
                        .then(() => {
                          this.$router.push({ name: "NoteLogin" });
                        })
                        .catch(() => {});
                    } else {
                      this.$toast(res.data.message);
                    }
                  }
                }
              );
            } else {
              if (res.data.message == "token验证失败") {
                this.$dialog
                  .confirm({
                    title: "提示 ",
                    message: "您还未登录是否去登录？"
                  })
                  .then(() => {
                    this.$router.push({ name: "NoteLogin" });
                  })
                  .catch(() => {});
              } else {
                if (res.data.message == "非法链接") {
                  this.$dialog
                    .confirm({
                      title: "提示 ",
                      message: "您还未登录是否去登录？"
                    })
                    .then(() => {
                      this.$router.push({ name: "NoteLogin" });
                    })
                    .catch(() => {});
                } else {
                  this.$toast(res.data.message);
                }
              }
            }
          },
          err => {
            this.$router.push({ name: "Overtime" });
          }
        );
      } else {
        this.$dialog
          .confirm({
            title: "提示 ",
            message: "您还未登录是否去登录？"
          })
          .then(() => {
            this.$router.push({ name: "NoteLogin" });
          })
          .catch(() => {});
      }
    },
    menu: function() {
      var _this = this;
      window.addEventListener("scroll", function() {
        if (_this.$route.name == "Goods") {
          var toop = document.getElementById("lvse").offsetTop - 44;
          if (document.documentElement.scrollTop >= toop) {
            _this.vanTabs = true;
          } else if (document.documentElement.scrollTop < toop) {
            _this.vanTabs = false;
          }
        }
      });
    },
    cartnum: function() {
      //购物车数量
      var mallid = localStorage.getItem("mallid");
      var isUser = localStorage.getItem("BLHuser");
      this.$api.get(
        "/user/cart/count",
        { id_example: mallid, token_user: isUser },
        res => {
          if (res.data.code == "100") {
            this.shopnum = res.data.data;
          }
        }
      );
    }
  },
  mounted() {
    this.getDatas();
    this.isLogin = localStorage.getItem("user_id") !== undefined && localStorage.getItem("user_id") !== null
    console.log(11111, localStorage.getItem("user_id"))
    //      this.cartnum()
    //      this.checkAddress()
  }
};
</script>
<style lang="less">
.van-button__content {
  color: #fff;
}
.goodsdetail {
  min-height: 100vh;
  padding-bottom: 1.2rem;
  background-color: #fff;
  .detail-content {
    width: 100%;
    .product-detail {
      box-sizing: border-box;
      padding: 0.26rem 0.3rem 0.2rem 0.3rem;
      .product-price {
        margin-bottom: 0.24rem;
        .product-price-jf {
          font-size: 0.36rem;
          font-weight: 500;
          color: #fe5c42;
          line-height: 0.5rem;
        }

        .product-price-jg {
          font-size: 0.24rem;
          font-weight: 400;
          color: #929292;
          line-height: 0.42rem;
          text-decoration: line-through;
        }
      }

      .product-name {
        font-size: 0.32rem;
        font-weight: 500;
        color: #262626;
        line-height: 0.44rem;
      }

      .product-number {
        font-size: 0.24rem;
        font-weight: 400;
        color: #929292;
        line-height: 0.42rem;
        margin-top: 0.1rem;
      }
      .stock-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.24rem;
        font-weight: 400;
        color: #929292;
        margin-top: 0.1rem;
      }
    }

    .product-set {
      border-top: 0.2rem solid #f5f5f5;
      border-bottom: 0.2rem solid #f5f5f5;

      .product-set-cont {
        padding: 0 0.3rem;
        box-sizing: border-box;

        .set-title {
          font-size: 0.28rem;
          font-weight: 400;
          color: #262626;
          line-height: 0.48rem;
          display: flex;
          align-items: center;

          img {
            width: 0.36rem;
            height: 0.36rem;
          }
        }

        .change-number {
          width: 100%;
          height: 1.2rem;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .set-stepper {
            display: flex;
            align-items: center;
          }
        }

        .product-address {
          border-top: 0.01rem solid #f2f2f2;
          width: 100%;
          height: 1.2rem;
          padding: 0.3rem 0 0.2rem 0;
          display: flex;
          flex-direction: column;

          .ps {
            display: flex;
          }

          .change-address {
            flex: 1;
            display: flex;
            justify-content: space-between;
          }

          .xh {
            font-size: 0.28rem;
            font-weight: 400;
            color: #fe5c42;
            line-height: 0.4rem;
            padding-left: 1.11rem;
            padding-top: 0.2rem;

            span {
              font-size: 0.24rem;
              font-weight: 400;
              color: #929292;
            }
          }
        }
      }
    }

    .product-xq {
      .xq-title {
        width: 100%;
        box-sizing: border-box;
        padding: 0.2rem 0 0 0.3rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #262626;
        line-height: 0.48rem;
        margin-bottom: 0.2rem;

        &::after {
          content: "";
          display: block;
          margin-top: 0.1rem;
          width: 1.06rem;
          height: 0.04rem;
          background: #e43833;
        }
      }
    }
  }

  .down {
    box-shadow: 0rem 0rem 0.02rem 0.01rem #f2f2f2;
    bottom: 0.51rem;
    height: 0.4rem;
    line-height: 0.4rem;
    text-align: center;
    background: #999 !important;
    color: #fff;
    span {
      display: inline-block;
      width: 100%;
      text-align: center;
    }
  }
  [class*="van-hairline"]:after {
    border: none;
  }
  .noMargin {
    margin: 0 !important;
  }
  .van-button--warning {
    border: none;
  }
  .van-goods-action {
    z-index: 100;
    background: #fff;
    padding: 0 0.2rem;
    height: 1.2rem;
    border-top: 0.02rem solid rgba(243, 243, 243, 1);

    .product-cart {
      width: 1.2rem;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 0.2rem;
      font-weight: 400;
      color: #262626;
      line-height: 0.28rem;

      img {
        width: 0.48rem;
        height: 0.48rem;
      }

      .cartNum {
        display: inline-block;
        width: 0.28rem;
        height: 0.28rem;
        line-height: 0.28rem;
        border-radius: 50%;
        text-align: center;
        position: absolute;
        top: -0.04rem;
        right: 0.25rem;
        color: #fff;
        background-color: rgba(254, 92, 66, 1);
      }
    }

    .forBag {
      flex: 1;
      display: flex;
      justify-content: flex-end;

      .van-button {
        flex: none;
        width: 3.2rem;
        height: 0.8rem;
        background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
        border-radius: 0.48rem;
      }
    }

    .immediately {
      width: 100%;
      display: flex;
      justify-content: flex-end;

      .immediately-change {
        flex: none;
        width: 100%;
        height: 0.8rem;
        background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
        border-radius: 0.48rem;
      }
    }
  }
  .van-button--large {
    width: 50%;
    line-height: 0.4rem;
    margin-top: 0.05rem;
    border-radius: 0.4rem;
    flex: 1;
  }
  .van-goods-action-mini-btn {
    min-width: 22%;
  }
  .goodsName {
    .ellipseal {
      height: auto;
      font-size: 1.6rem;
      font-weight: bolder;
      line-height: normal !important;
      -webkit-line-clamp: 4;
    }
  }
  .van-sku-container {
    overflow: inherit;
  }
  .brandbox {
    width: 100%;
    display: inline-block;
    position: relative;
    .brandimg {
      width: 0.8rem;
      height: 0.8rem;
    }
    .brand-referral {
      position: absolute;
      width: 100%;
      top: 0;
      padding-left: 0.9rem;
      box-sizing: border-box;
      .brand-title {
        font-size: 0.2rem;
        font-weight: bold;
        margin-bottom: 0.05rem;
      }
      .brand-detail {
      }
    }
  }
  .product-oldprice {
    text-decoration: line-through;
    color: #999;
  }
  .van-stepper__input {
    vertical-align: top;
  }
  .van-hairline--top-bottom::after {
    border-width: 0;
  }
  .div:not(:last-child)::after {
    border-bottom-width: 0;
  }
  .van-tabs {
    z-index: 0;
    background: #fff;
  }
  .div,
  .div {
    background-color: #fff;
  }
  .van-button--bottom-action {
    line-height: 0.48rem;
  }
  .tabtop .van-tabs__wrap--content-top {
    position: fixed;
    top: 0.44rem;
  }
  .goodstab {
    padding: 0 0.3rem;
    padding-bottom: 0.5rem;
  }
  .goodstab span {
    white-space: normal !important;
  }
  .goodstab img {
    width: 100%;
    height: auto !important;
  }
  .goodstab table,
  .goodstab tr {
    width: 100% !important;
    height: auto !important;
  }
  .goodstab div {
    width: 100% !important;
  }
  .goodstab div,
  .goodstab p {
    zoom: 1;
  }
  .goodstab div:before,
  .goodstab p:before,
  .goodstab div:after,
  .goodstab p:after {
    display: table;
    content: "";
    line-height: 0;
  }
  .goodstab div:after,
  .goodstab p:after {
    clear: both;
  }
  .countbox {
    background-color: #ff8700;
    color: #fff;
    padding: 0.1rem 0.15rem;
    font-size: 1.6rem;
    overflow: hidden;
  }
  .radius {
    -webkit-border-radius: 0.02rem;
    -moz-border-radius: 0.02rem;
    border-radius: 0.02rem;
    color: #fff;
    padding: 0.02rem 0.05rem;
  }

  .out-stock {
    width: 3.2rem;
    height: 0.8rem;
    background: linear-gradient(111deg, #b9b9b9 0%, #8f8f8f 100%);
    border-radius: 0.48rem;
    flex: none;
    margin-left: 1.2rem;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/detail.vue